<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 3761 3761"
       xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Vrstva_x0020_1">
    <g id="_882973272">
     <path class="fil0"
           d="M3761 3378c0,211 -172,383 -383,383l-2996 0c-211,0 -382,-172 -382,-383l0 -2996c0,-211 171,-382 382,-382l2996 0c211,0 383,171 383,382l0 2996z"/>
      <g>
      <path class="fil1"
            d="M1778 1715c0,313 -369,408 -459,702 -26,84 -29,159 -7,247 50,198 225,342 415,384 22,4 48,7 63,14 -6,-26 -20,-44 -30,-66 -10,-22 -17,-43 -26,-69 -62,-188 -13,-404 108,-552 78,-94 154,-143 250,-257 68,-79 71,-129 97,-242 -7,-12 -32,-42 -43,-52l-53 -48c-61,-59 -152,-124 -224,-169 -42,-27 -83,-48 -127,-71 2,24 17,61 23,85 8,30 13,58 13,94z"/>
        <path class="fil1"
              d="M1844 2752c0,100 45,217 106,288 20,25 24,25 97,5 217,-61 417,-240 417,-472 0,-168 -25,-299 -100,-449 -11,-22 -18,-32 -29,-53 -12,-22 -20,-40 -38,-52 -2,59 -70,155 -100,192 -103,125 -164,157 -224,224 -73,83 -129,206 -129,317z"/>
     </g>
      <path class="fil2 str0"
            d="M914 1039l1932 0c79,0 151,32 202,84 52,52 84,123 84,202l0 1932 0 4 -207 0 0 -4 0 -1932c0,-22 -8,-41 -23,-56 -14,-14 -34,-23 -56,-23l-1932 0c-21,0 -41,9 -56,23 -14,15 -23,34 -23,56l0 1932 0 4 -207 0 0 -4 0 -1932c0,-79 32,-150 84,-202 52,-52 124,-84 202,-84z"/>
      <rect class="fil3 str0" x="371" y="730" width="3019" height="207" rx="103" ry="104"/>
      <rect class="fil3 str0" x="371" y="3219" width="3019" height="207" rx="103" ry="104"/>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'Fireplace',
};
</script>

<style scoped>
.str0 {
  stroke: #56D6D1;
  stroke-width: 32.5056
}

.fil0 {
  fill: none;
  fill-rule: nonzero
}

.fil3 {
  fill: #56D6D1
}

.fil1 {
  fill: #F69036
}

.fil2 {
  fill: #56D6D1;
  fill-rule: nonzero
}
</style>
